<div class="content-block">
  <div class="main-block">
    <div class="tasks-columns">
      <app-task-column [tasksForMe]="true"></app-task-column>
      <app-task-column [tasksForMe]="false"></app-task-column>
    </div>

    <div class="nfs-columns" *ngIf="currentUser.installationUser">
      <app-installer-quotes></app-installer-quotes>
    </div>

    <div class="nfs-columns" *ngIf="!currentUser.installationUser">
      <app-mentions-column></app-mentions-column>

      <app-alerts-column></app-alerts-column>

      <app-client-nfs-column *ngIf="showClientNfs">
      </app-client-nfs-column>
    </div>

  </div>
</div>
